export interface DataEntity_Detail_03_01_Interface {
  id: number,
  main_id: number,

  setPoint: string,
  uncertainty: string,
  instability: string,
  inhomogeneity: string,
  converage: string,
  indication: string,
  zFactor: string,
  correction: string,
  reference: string,
  predix: string,

  value: string,
  before:boolean,
  status:number,
}

export function Empty_DataEntity_Detail_03_01_Interface(): DataEntity_Detail_03_01_Interface {
  return {
    id: 0,
    main_id: 0,

    setPoint: '',
    inhomogeneity: '',
    instability: '',
    uncertainty: '',
    converage: '',
    indication: '',
    zFactor: '',
    correction: '',
    reference: '',
    value: '',
    predix: '',
    status:0,

    before:false
  }
}
